import { Navigate, Route } from 'react-router-dom';
import { CommunityPathFallback } from '@/components/routing/CommunityPathFallback';
import CommunityDashboardRouter from '@/pages/dashboard/CommunityDashboardRouter';

/**
 * Routes shared by COMMUNITY and AGGREGATOR (same URL, page chosen by kind).
 * Must be real `<Route>` / Fragment children — not a wrapper component.
 */
export const sharedCommunityRoutes = (
  <>
    <Route index element={<Navigate to="dashboard" replace />} />
    <Route path="dashboard" element={<CommunityDashboardRouter />} />
  </>
);

export const communityPathFallbackRoute = <Route path="*" element={<CommunityPathFallback />} />;
